import { EthereumNetwork } from "../graphql.js"
import { BitcoinNetworkNames, BlockchainNetwork, CosmosNetwork } from "../constants.js"

export const getBlockchainFromNetwork = (network: string) => {
    if (Object.values(EthereumNetwork).includes(network as EthereumNetwork)) {
        return BlockchainNetwork.ethereum
    }
    if (Object.keys(BitcoinNetworkNames).includes(network)) {
        return BlockchainNetwork.bitcoin
    }
    if (Object.keys(CosmosNetwork).includes(network)) {
        return BlockchainNetwork.cosmos
    }

    return network as BlockchainNetwork
}
